import type { ConversationDetail } from '@/shared/api'
import { Icon } from '@/shared/ui'
import { guestDisplayName } from '@/shared/lib/format'
import s from './ConversationBookingContext.module.css'

type Booking = NonNullable<ConversationDetail['booking']>

/*
 * ⚠️ КАРТОЧКИ «ОТВЕТСТВЕННЫЙ» ЗДЕСЬ НЕТ: исполнителя у переписки нет как понятия — поле приходит
 * `null` всегда, потому что в inbox нет ни поля, ни операции, которые бы его заводили. Аватар с
 * именем утверждал бы, что у диалога есть хозяин, и это единственное, что делало бы осмысленным
 * фильтр «Мои». Появится сервис, который заведёт понятие, — вернём.
 */
type ConversationBookingContextProps = {
  booking?: Booking | null
  onOpenBooking: (bookingId: string) => void
}

export function ConversationBookingContext({
  booking,
  onOpenBooking,
}: ConversationBookingContextProps) {
  if (!booking) {
    return (
      <div className={s.card}>
        <div className={s.emptyIcon}>
          <Icon name="email" size={16} strokeWidth={1.9} />
        </div>
        <div className={s.emptyTitle}>Бронь не привязана</div>
        <div className={s.emptyText}>Контекст появится, когда диалог свяжут с бронью.</div>
      </div>
    )
  }

  return (
    <section className={s.card} aria-label="Контекст брони">
      <div className={s.kicker}>Бронь</div>
      <div className={s.guest}>{guestDisplayName(booking.guestName)}</div>

      <div className={s.meta}>
        <span className={s.objectCode}>{booking.objectCode}</span>
        <span>{booking.datesLabel}</span>
      </div>

      <div className={s.stage}>{booking.stageLabel}</div>

      <button type="button" className={s.primary} onClick={() => onOpenBooking(booking.id)}>
        Открыть бронь
      </button>
    </section>
  )
}
